import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { forwardRef, useImperativeHandle, useState } from "react";
import CancelIcon from "../../../assets/icons/cross-bold-icon.png";
import GlobalButton from "../../../components/button";
import Label from "../../../components/label";
import TextInput from "../../../components/textInput";
import { createProduct, updateProduct } from "../../../services/ProductApi";
import { handleApiCall } from "../../../utils/helper";
import AppLoader from "./../../../components/loader/index";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": { padding: theme.spacing(2) },
  "& .MuiPaper-root": {
    width: "600px",
    [theme.breakpoints.down("sm")]: { margin: 12 },
  },
}));

const AddEditProductDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState("");
  const [error, setError] = useState(false);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      setOpen(true);
      setDialogData(params);

      if (params.type === "edit") {
        const { data } = params;
        setName(data?.name);
      }
    },
    disable() {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setName("");
  };

  const handleAddEditEquipment = async () => {
    if (!name.trim()) {
      return setError(true);
    }

    if (dialogData?.type === "add") {
      handleApiCall(
        "",
        createProduct,
        { name },
        setIsLoading,
        handleClose,
        dialogData.getData
      );
    } else {
      handleApiCall(
        dialogData?.data?._id,
        updateProduct,
        { name },
        setIsLoading,
        handleClose,
        dialogData.getData
      );
    }
  };

  return (
    <BootstrapDialog onClose={handleClose} open={open}>
      <AppLoader isVisible={isLoading} />
      <Stack
        p={2}
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography
          variant="h1"
          fontSize={"1.5rem"}
          fontWeight={500}
          color={"secondary.dark"}
        >
          {dialogData?.type === "add" ? "Add Product" : "Edit Product"}
        </Typography>
        <IconButton onClick={handleClose}>
          <img src={CancelIcon} alt="cancel-icon" width={25} />
        </IconButton>
      </Stack>
      <DialogContent dividers>
        <Box margin={"auto"}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Label title={"Product Name"} required htmlFor={"product-name"} />
              <TextInput
                id={"product-name"}
                type={"text"}
                required
                error={error}
                helperText={error && "Product name is required"}
                defaultStyle={true}
                placeholder={"Enter product name"}
                value={name}
                name={"name"}
                onChange={(e) => {
                  setError(false);
                  setName(e.target.value);
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant={"custom_gradient"}
          handleClickBtn={handleClose}
          title={"Cancel"}
          style={{
            width: 100,
            background: "red !important",
          }}
        />
        <GlobalButton
          variant={"custom_gradient"}
          title={dialogData?.type === "add" ? "Add" : "Update"}
          style={{ width: 100 }}
          handleClickBtn={handleAddEditEquipment}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default AddEditProductDialog;
